import Styles from './ProjectCard.module.scss'
import * as CSS from 'csstype'
import cx from 'classnames'
import { Heading } from 'almanac-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Icon as IconType } from 'blaze-ui/icons/Types'

interface Props {
  icon: IconType
  color: string
  title: string
  description: string
  dataTestId: string
  isDisabled?: boolean
  isSelected?: boolean
  onClick?: () => void
}

export const ProjectCard = ({
  icon: Icon,
  color,
  title,
  description,
  dataTestId,
  isDisabled = false,
  isSelected = false,
  onClick,
}: Props) => {
  const style: CSS.Properties = {
    ['--card-bg-color' as any]: color,
  }

  return (
    <div
      className={cx(Styles.card, { [Styles.isDisabled]: isDisabled, [Styles.isSelected]: isSelected })}
      onClick={onClick}
      style={style}
      data-testid={dataTestId}
    >
      <div className={Styles.headerContainer}>
        <div className={Styles.header}>
          <span className={Styles.icon} style={{ background: color }}>
            <Icon color="var(--light-100)" />
          </span>
          {isDisabled && <div className={Styles.comingSoon}>Coming soon</div>}
        </div>
        <Heading level={4} color={isDisabled ? 'var(--neutral-30)' : undefined}>
          {title}
        </Heading>
      </div>
      <Text variant="secondary" color="var(--dark-80)">
        {description}
      </Text>
    </div>
  )
}
